import Vue from 'vue'

import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import HomeMap from '@/components/maps/HomeMap'

import About from '@/components/about/About'
import Help from '@/components/about/Help'

// Dashboards & Reporting
import Dashboard from '@/components/dashboard/Dashboard'

import BackhaulDashboard from '@/components/dashboard/backhaul/BackhaulDashboard'

// import SharerDashboard from '@/components/dashboard/sharers/SharerDashboard'
import FinanceSummary from '@/components/dashboard/views/FinanceSummary'
import PropertyDashboard from '@/components/dashboard/property/PropertyDashboard'
import UtilityReport from '@/components/dashboard/utility/UtilityReport'
import ProjectSummary from '@/components/dashboard/views/ProjectSummary'

import ProgressReport from '@/components/dashboard/progress/ProgressReport'


// Sites
import SitesTable from '@/components/tables/SitesTable'
import RequestsView from '@/components/requests/RequestsView'

import Equip from '@/components/assets/EquipView'
import EventsCalendar from '@/components/atoms/EventsCalendar'


// Finance
import StatementView from '@/components/dashboard/finance/StatementView'
import InvoicingView from '@/components/finance/InvoicingView'
import RevenueReport from '@/components/dashboard/finance/RevenueReport'
import BackhaulTable from '@/components/backhaul/BackhaulTable'
import UtilitiesTable from '@/components/utility/UtilitiesTable'


// Property
import PropertyLandlords from '@/components/dashboard/property/PropertyLandlords'
import PropertyExpiry from '@/components/dashboard/property/PropertyExpiry'
import PropertyRentalMonth from '@/components/dashboard/property/PropertyRentalMonth'
import TenancyDue from '@/components/dashboard/property/TenancyDue'


// Maintenance
import MaintView from '@/components/maintenance/MaintenanceView'
import MaintCalendar from '@/components/maintenance/MaintCalendar'

// import SiteOmsTasks from '@/containers/SiteOmsTasks'
// import Workflow from '@/containers/Workflow'


// Profile & Settings
import UserProfile from '@/components/login/UserProfile'
import SettingsView from '@/components/settings/SettingsView'

import Login from '@/components/login/Login'
import Logout from '@/components/login/Logout'

import {settings} from '@/components/Data'
import { migrationRewrite } from '@/lib/routerMigration'

Vue.use(Router)

// XOL-293: Every route must preserve a /d.<x> drawer tail so that
// $route.path contains the full drawer URL on cold load. Routes that already
// carry :drawerPath(.*)?  are left as-is; all others get an optional param
// that only matches segments starting with "d." via the anchored pattern
// /:drawerPath(d\\..*)?  — path-to-regexp v1 / vue-router 2 syntax.
// The root path is handled specially: /  +  /:drawerPath(d\\..*)?  would
// require a leading slash which forces an empty first segment; instead we
// write the root as  /:drawerPath(d\\..*)?  (vue-router treats it as an
// optional first-segment-only match relative to /).
//
// Routes that already have :drawerPath(.*)?  already capture any tail, so
// the d.-anchor is not applied to those (they continue to work as before).
//
// /tickets already has :status?/:priority?/:ownerId? — we append the
// d.-anchored tail after those params. NOTE: a drawer segment can still bind
// to an EARLIER optional slot (e.g. /tickets/d.ticket.9 lands "d.ticket.9" in
// :status) because those params are unanchored and greedy — the d.-anchor on
// :drawerPath only constrains what drawerPath itself matches, not the params
// before it. That misbinding is harmless: DrawerStack derives its stack from
// $route.path directly (not params.drawerPath), and MaintView's notDrawer()
// guard treats any "d."-prefixed param value as absent.

const router = new Router({
  routes: [
    {
      // Root: match both / and /d.<x> at the top level.
      path: '/:drawerPath(d\\..*)?',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/help/:drawerPath(d\\..*)?',
      name: 'Help',
      component: Help
    },
    {
      path: '/about/:drawerPath(d\\..*)?',
      name: 'About',
      component: About
    },
    {
      path: '/map/:drawerPath(d\\..*)?',
      name: 'Map',
      component: HomeMap
    },
    {
      path: '/dashboard/:drawerPath(d\\..*)?',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/dashboard/backhaul/:drawerPath(.*)?',
      name: 'Backhaul Dashboard',
      component: BackhaulDashboard
    },
    {
      path: '/dashboard/projects/:drawerPath(d\\..*)?',
      name: 'Project Dashboard',
      component: ProjectSummary
    },
/*
    {
      path: '/dashboard/sharers',
      name: 'Sharer Dashboard',
      component: SharerDashboard
    },
*/
    {
      path: '/dashboard/finance/:drawerPath(d\\..*)?',
      name: 'Finance Summary',
      component: FinanceSummary
    },
    {
      path: '/dashboard/property/:drawerPath(d\\..*)?',
      name: 'Property Dashboard',
      component: PropertyDashboard
    },
    {
      path: '/dashboard/utility/:drawerPath(d\\..*)?',
      name: 'Utility Dashboard',
      component: UtilityReport
    },
    {
      path: '/dashboard/requests/:drawerPath(d\\..*)?',
      name: 'Dashboard Requests',
      component: Dashboard
    },
    {
      path: '/dashboard/maintenance/:drawerPath(.*)?',
      name: 'Maintenance Dashboard',
      component: MaintView
    },
    {
      path: '/dashboard/progress/:drawerPath(d\\..*)?',
      name: 'Progress',
      component: ProgressReport
    },
    {
      path: '/calendar/:drawerPath(d\\..*)?',
      name: 'Events Calendar',
      component: EventsCalendar
    },
    {
      path: '/sites/:drawerPath(.*)?',
      name: 'sites',
      component: SitesTable
    },
    // XOL-209 PR 3: /requests → /requests/summary default tab redirect.
    // Redirect must appear BEFORE the parameterised record; vue-router matches
    // top-down and `:typeSlug?` would also match the bare `/requests` path.
    { path: '/requests', redirect: '/requests/summary' },
    {
      // Keep slug list in sync with src/lib/requestTypeSlugs.js
      path: '/requests/:typeSlug(summary|acquire|shares|upgrades|backhaul|dismantle|calendar)?/:drawerPath(.*)?',
      name: 'Requests',
      component: RequestsView
    },
    {
      path: '/backhaul/:drawerPath(.*)?',
      name: 'Backhaul',
      component: BackhaulTable
    },
    {
      path: '/assets/:drawerPath(d\\..*)?',
      name: 'Equip',
      component: Equip
    },
    {
      path: '/property/rentals/:drawerPath(d\\..*)?',
      name: 'Rentals By Month',
      component: PropertyRentalMonth
    },
    {
      path: '/property/due/:drawerPath(d\\..*)?',
      name: 'Tenancy Due',
      component: TenancyDue
    },
    {
      path: '/property/expiry/:drawerPath(d\\..*)?',
      name: 'Tenancy Expiry',
      component: PropertyExpiry
    },
    {
      path: '/property/landlords/:drawerPath(d\\..*)?',
      name: 'Landlords',
      component: PropertyLandlords
    },
    {
      path: '/statements/:drawerPath(d\\..*)?',
      name: 'Statements',
      component: StatementView
    },
    {
      path: '/revenue/:drawerPath(d\\..*)?',
      name: 'Sharer Revenue',
      component: RevenueReport
    },
    {
      path: '/invoices/:drawerPath(d\\..*)?',
      name: 'Invoicing',
      component: InvoicingView
    },
    {
      path: '/utility/:drawerPath(.*)?',
      name: settings.utilLabel + ' Bills',
      component: UtilitiesTable
    },
    {
      // XOL-293: d.-anchored tail appended after the existing optional params.
      // A drawer segment may bind to an earlier slot (e.g. /tickets/d.ticket.9
      // lands "d.ticket.9" in :status) since those params are greedy — harmless:
      // DrawerStack reads $route.path directly, and MaintView.notDrawer() treats
      // any "d."-prefixed value as absent. See the header note above.
      path: '/tickets/:status?/:priority?/:ownerId?/:drawerPath(d\\..*)?',
      name: 'Tickets',
      props: true,
      component: MaintView
    },
    {
      path: '/maintenance/:drawerPath(d\\..*)?',
      name: 'Maintenance',
      component: MaintCalendar
    },
    {
      path: '/profile/:drawerPath(d\\..*)?',
      name: 'User Profile',
      component: UserProfile
    },
    {
      // XOL-317: settingTab + financeTab are enum-constrained so a drawer-only URL
      // (e.g. /settings/d.org.5) falls through to :drawerPath, matching the
      // /tickets greedy-param convention. Keep enum lists in sync with src/lib/settingsSlugs.js.
      path: '/settings/:settingTab(orgs-xolas|orgs-telco|orgs-contractor|orgs-backhaul|orgs-landlord|orgs-insurer|orgs-utility|orgs-authority|orgs-tower-supplier|workflow|cats|loc|struct|finance|backup|logs)?/:financeTab(settings|agreements|audit|rates|builder|bulk)?/:drawerPath(d\\..*)?',
      name: 'Settings',
      component: SettingsView
    },
    {
      path: '/login/:drawerPath(d\\..*)?',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout/:drawerPath(d\\..*)?',
      name: 'Logged Out',
      component: Logout
    }
  ]
})

// Permanent URL migration shim (XOL-209 PR 2/3). See src/lib/routerMigration.js.
// Rewrites legacy route patterns to canonical d.<component>.<args> URLs.
// PERMANENT — do not remove. Old URLs live in bookmarks, emails, QR codes.
//
// Rules may return either a string (path only, PR 1/PR 2 behaviour) or an
// object {path, query} (PR 3 request rules that carry ?sharerId=). The shim
// merges the rule's query with the incoming to.query (incoming keys win on
// collision, preserving bookmarked ?sharerId= overrides).
router.beforeEach(function (to, from, next) {
  var rewritten = migrationRewrite(to.path)
  if (rewritten === null || rewritten === undefined) {
    return next()
  }
  // Normalise string result to {path, query} shape for uniform handling
  if (typeof rewritten === 'string') {
    rewritten = { path: rewritten }
  }
  // No-op guard: string-only rules that returned the same path
  if (rewritten.path === to.path && !rewritten.query) {
    return next()
  }
  // Merge query: rule-provided keys merged with incoming; incoming wins on collision
  var mergedQuery = Object.assign({}, rewritten.query || {}, to.query || {})
  return next({
    path: rewritten.path,
    query: Object.keys(mergedQuery).length ? mergedQuery : undefined,
    hash: to.hash || undefined
  })
})

export default router
